import { render, staticRenderFns } from "./ShortText.vue?vue&type=template&id=09ad0ed0&scoped=true"
import script from "./ShortText.vue?vue&type=script&lang=js"
export * from "./ShortText.vue?vue&type=script&lang=js"
import style0 from "./ShortText.vue?vue&type=style&index=0&id=09ad0ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ad0ed0",
  null
  
)

export default component.exports